import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 9h4a2 2 0 0 0 2-2V3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "9", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 21v-4a2 2 0 0 1 2-2h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "15", cy: "15", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CircuitBoard";
const CircuitBoard = memo(themed(Icon));
export {
  CircuitBoard
};
//# sourceMappingURL=circuit-board.js.map
